module.exports = __webpack_public_path__ + "static/img/增值税管理云2.a91f761f.png";